import { getAllEmployees } from 'apis/employees.api';
import { useMemo } from 'react';
import { useQuery } from 'react-query';

const useGetAllEmployees = (pagination, search, conds) => {
  const { data, ...rest } = useQuery(
    ['getAllEmployees', pagination, search],
    () => getAllEmployees(pagination, search),
    {
      ...conds,
    }
  );

  const employees = useMemo(
    () => data?.data ?? { data: [], pagination: { row: 10, totalRecords: 0 } },
    [data]
  );

  return {
    data: employees,
    ...rest,
  };
};

export default useGetAllEmployees;
